module.exports = __webpack_public_path__ + "static/media/steel_2.729311e1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/textures/steel_2.jpg
// module id = 327
// module chunks = 0